// extracted by mini-css-extract-plugin
export default {"root":"EmptyHistoryReports_root__hgcxD","description":"EmptyHistoryReports_description__m5aGg"};